export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          关于天天影院
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          用心打造的免费高清在线观影平台
        </p>

        <div className="bg-background-100 border border-background-200/60 rounded-xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500 text-lg"></i>
              </span>
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950">天天影院</h3>
              <p className="text-xs text-foreground-500">成立于2023年 · 服务超过500万影迷</p>
            </div>
          </div>

          <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              天天影院是一个专注于提供<strong className="text-foreground-900">最新电影大全</strong>、
              <strong className="text-foreground-900">动作片在线</strong>、
              <strong className="text-foreground-900">喜剧片免费看</strong>、
              <strong className="text-foreground-900">科幻片高清播放</strong>及
              <strong className="text-foreground-900">经典电影全集</strong>的免费在线观影平台。
              我们致力于为每一位影迷打造纯净、流畅、高清的观影环境，让好电影触手可及。
            </p>
            <p>
              自上线以来，天天影院始终坚持「极速播放、海量片库、免费高清」的核心理念，
              每日持续更新片库资源，覆盖动作、喜剧、科幻、悬疑、爱情、动画等多类型电影，
              已累计服务超过500万影迷用户，是您身边最值得信赖的电影大全。
            </p>
            <p>
              我们相信，好的电影不应该有门槛。天天影院团队将持续优化播放体验，
              不断扩充片库资源，让每一位用户都能在这里找到想看的电影，享受纯粹的观影乐趣。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/40">
            <div className="text-center">
              <div className="text-xl font-heading font-bold text-primary-500">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">累计影迷</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-heading font-bold text-primary-500">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">影片资源</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-heading font-bold text-primary-500">3年</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-heading font-bold text-primary-500">99.9%</div>
              <div className="text-xs text-foreground-500 mt-1">可用率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}